import {
  ActionList,
  ActionItem,
  renderApproveContracts,
} from '@/presentation/components/modules/ActionList';
import { SwapPrice } from '@/core/swap';
import { TransactionState } from '@nftx/react';
import { useFormatter, useTranslations } from 'use-intl';
import { formatEther } from 'viem';
import Icon, { Icons } from '@/presentation/components/elements/Icon';
import ellipsis from '@/presentation/utils/ellipsis';
import { Chain } from 'wagmi';
import { TokenIds, getTotalTokenIds, getUniqueTokenIds } from 'nftx.js';

export const SwapProcessing = ({
  network,
  quote,
  sellSymbol,
  buySymbol,
  buyAmount,
  sellAmount,
  buyItems,
  sellItems,
  action,
  actionError,
  actionStatus,
  onCancel,
  onComplete,
  txHash,
  chain,
}: {
  network: number;
  quote: SwapPrice;
  sellSymbol: string;
  buySymbol: string;
  buyAmount: `${number}`;
  sellAmount: `${number}`;
  buyItems: TokenIds;
  sellItems: TokenIds;
  action: () => Promise<any>;
  actionError: any;
  actionStatus: TransactionState;
  onCancel: () => void;
  onComplete: () => void;
  txHash?: `0x${string}` | undefined;
  chain: Chain;
}) => {
  const { number } = useFormatter();
  const t = useTranslations('Swap.Processing');
  const actionItems: JSX.Element[] = [];

  actionItems.push(
    ...renderApproveContracts({
      approveContracts: quote.approveContracts,
      index: actionItems.length,
      network,
      symbol: sellSymbol,
    })
  );

  actionItems.push(
    <ActionItem
      key={actionItems.length}
      index={actionItems.length}
      action={action}
      label={t(`${quote.type}.title`, { buySymbol, sellSymbol })}
      error={actionError}
      status={actionStatus}
    />
  );

  return (
    <div className="p-6 bg-gray-50 w-full">
      <ActionList
        title={t(`${quote.type}.title`, { buySymbol, sellSymbol })}
        description={t(`${quote.type}.description`, {
          amount: number(Number(formatEther(quote.amount))),
          sellAmount,
          buyAmount,
          buySymbol,
          sellSymbol,
          buyTokenIds: getUniqueTokenIds(buyItems).join(', '),
          sellTokenIds: getUniqueTokenIds(sellItems).join(', '),
          sellNftAmount: getTotalTokenIds(sellItems),
          buyNftAmount: getTotalTokenIds(buyItems),
        })}
        onCancel={onCancel}
        onComplete={onComplete}
      >
        {actionItems}
      </ActionList>
      {txHash && (
        <p className="text-center mt-4 text-sm">
          <a
            href={`${chain.blockExplorers?.default.url}/tx/${txHash}`}
            className="inline-flex items-center hover:underline"
            target="_blank"
            rel="nofollow noreferrer"
          >
            {t('tx', { hash: ellipsis(txHash) })}
            <Icon name={Icons.EXTERNAL} size={12} className="ml-1" />
          </a>
        </p>
      )}
    </div>
  );
};

export default SwapProcessing;
